/* the home page's quiet machinery: film mount with a visible pause,
   click-to-load video facades, and fade-in reveals. everything honours
   reduced motion and nothing runs before the page is settled. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* hero film: the poster is server-rendered so it paints instantly, and
     the film's source is held in data-src until we know the screen is
     wide enough to be worth 419KB. we mount it, wire the visible pause
     control (WCAG 2.2.2), and never fetch it for a phone or for a
     reduced-motion reader. */
  var v = document.querySelector('.hero-video');
  var wideEnough = window.matchMedia('(min-width: 56rem)').matches;
  if (v) {
    if (reduced || !wideEnough) {
      /* a phone gets the poster and nothing else: the film is 419KB and
         a full-viewport video to composite, for decoration behind text. */
      v.pause();
      v.removeAttribute('data-src');
      v.removeAttribute('src');
      v.load();
    } else {
      v.src = v.getAttribute('data-src');
      v.play().catch(function () {});
      var btn = document.querySelector('.film-toggle');
      if (btn) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var playing = !v.paused;
          if (playing) { v.pause(); } else { v.play(); }
          btn.setAttribute('aria-pressed', String(playing));
          btn.querySelector('.when-playing').hidden = playing;
          btn.querySelector('.when-paused').hidden = !playing;
        });
      }
    }
  }

  /* film facades: the iframe exists only after a person asks for it */
  document.querySelectorAll('.film-facade-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var box = btn.closest('.film-facade');
      /* a self-hosted film sits in the facade already; on press it gets
         its controls and starts, and the poster button steps aside */
      var native = box.querySelector('video.film-native');
      if (native) {
        /* a film longer than Shopify's ten minutes is hosted in two parts:
           when part 1 ends, part 2 carries straight on in the same player */
        var nextSrc = native.getAttribute('data-next-src');
        if (nextSrc && !native.hasAttribute('data-chained')) {
          native.setAttribute('data-chained', '');
          native.addEventListener('ended', function onEnd() {
            native.removeEventListener('ended', onEnd);
            var nextCaptions = native.getAttribute('data-next-captions');
            var track = native.querySelector('track');
            if (nextCaptions && track) {
              var fresh = track.cloneNode(false);
              fresh.src = nextCaptions;
              track.replaceWith(fresh);
            }
            native.src = nextSrc;
            native.play().catch(function () {});
          });
        }
        /* the large poster is only wanted once the film is open: as a
           poster attribute on the hidden video it was fetched on every
           visit, beside the facade picture that is actually shown */
        if (native.dataset.poster && !native.getAttribute('poster')) native.setAttribute('poster', native.dataset.poster);
        native.hidden = false;
        native.setAttribute('controls', '');
        btn.hidden = true;
        native.focus();
        native.play().catch(function () {});
        return;
      }
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' +
        box.getAttribute('data-video-id') + '?autoplay=1&rel=0';
      frame.title = box.getAttribute('data-title');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'film-frame';
      btn.replaceWith(frame);
      frame.focus();
    });
  });

  /* fade-in reveals, instant under reduced motion */
  var faders = document.querySelectorAll('.fade-in');
  if (!('IntersectionObserver' in window) || reduced) {
    faders.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    faders.forEach(function (el) { io.observe(el); });
  }
})();

/* the mobile menu: lock the page behind it, close on escape or on
   choosing a destination */
(function () {
  'use strict';
  var menu = document.querySelector('.menu.nav-mobile');
  if (!menu) return;
  var burger = menu.querySelector('summary');
  var closeBtn = menu.querySelector('.menu-close');
  var sync = function () { document.body.classList.toggle('menu-open', menu.open); };
  var close = function (returnFocus) {
    if (!menu.open) return;
    menu.open = false; sync();
    if (returnFocus && burger) burger.focus();
  };
  menu.addEventListener('toggle', function () {
    sync();
    if (menu.open && closeBtn) closeBtn.focus();
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
  // a wider window shows the desk menu; a panel left open would sit under it
  window.matchMedia('(min-width: 62rem)').addEventListener('change', function (e) { if (e.matches) close(false); });
})();

/* the standing plate: which passage is in view decides which pull of
   the print is showing. opacity only, finished state is the default. */
(function () {
  'use strict';
  var standing = document.querySelector('[data-standing]');
  if (!standing || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var steps = standing.querySelectorAll('.standing-step');
  if (!steps.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        standing.setAttribute('data-at', e.target.getAttribute('data-stage'));
      }
    });
  }, { rootMargin: '-40% 0px -40% 0px' });
  steps.forEach(function (s) { io.observe(s); });
})();


/* Product gallery: turning between the pictures.

   Brett, 2026-09-06: clicking through them lagged. It did. Setting
   img.src to a file the browser has never fetched does not change the
   picture, it starts a download, and until that download and its decode
   finish the browser goes on painting the picture it already has. So
   the first click on every thumbnail cost a network round trip and the
   page looked frozen for it.

   Three things fix it, in order of how much they are worth:

     Fetch and DECODE before swapping. decode() resolves only when the
     bitmap is ready to paint, so the swap itself is one frame with no
     half-drawn state. Everything else here is in service of this
     resolving instantly.

     Warm them early. On a hover or a focus we fetch the one they are
     reaching for, and once the page is idle we fetch the rest, unless
     the connection has asked us not to. Save-Data and 2g get the hover
     path only.

     Cross-fade, briefly. All six pictures are the artwork's shape now,
     so nothing moves during the change and a short fade reads as
     turning a page rather than a flicker. Reduced motion gets the cut. */
(function () {
  'use strict';
  var main = document.getElementById('PdpImage') || document.querySelector('.pdp-wall img');
  if (!main) return;
  var thumbs = [].slice.call(document.querySelectorAll('.pdp-thumb'));
  if (!thumbs.length) return;

  // Picture 1 is already on the wall, at whatever width the srcset chose
  // for this screen. Its thumbnail pointed at the 1200px file, so warming
  // the set at idle downloaded the plate a second time. Point it at the
  // file already here and the warm-up finds it in the cache.
  function adoptPlate() {
    var src = main.currentSrc || main.src;
    if (src) thumbs[0].setAttribute('data-full', src);
  }
  if (main.complete && main.naturalWidth) adoptPlate();
  else main.addEventListener('load', adoptPlate, { once: true });

  // The other pictures were all warmed at 1200px, whatever the screen.
  // On a phone the plate's own srcset picks 640 or 880, so the idle
  // warm-up pulled about 850KB for a box that shows a third of it (the ink
  // close-up alone was 541KB). They now come at the width the plate chose;
  // the larger view keeps its own full-size set.
  function fitThumbs() {
    var m = /[?&]width=(\d+)/.exec(main.currentSrc || '');
    var w = m ? +m[1] : 0;
    if (!w || w >= 1200) return;
    thumbs.forEach(function (b, i) {
      if (i === 0) return;
      var u = b.getAttribute('data-full');
      if (u) b.setAttribute('data-full', u.replace(/([?&]width=)1200\b/, '$1' + w));
    });
  }
  fitThumbs();

  // The wall sizes the plate from a ratio before the file arrives (kit.css),
  // so every picture that lands, the room and the corner included, tells
  // the wall its own ratio.
  var plateFrame = main.closest('.framed--plate');
  function fitFrame() {
    if (plateFrame && main.naturalWidth && main.naturalHeight) {
      plateFrame.style.setProperty('--ar', (main.naturalWidth / main.naturalHeight).toFixed(4));
    }
  }
  main.addEventListener('load', fitFrame);

  var warmed = {};
  function warm(url) {
    if (!url) return Promise.resolve();
    if (warmed[url]) return warmed[url];
    var im = new Image();
    im.src = url;
    var p = im.decode ? im.decode().catch(function () {}) : Promise.resolve();
    warmed[url] = p;
    return p;
  }

  function mark(btn) {
    thumbs.forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }

  var turning = false;
  function swap(btn) {
    var url = btn.getAttribute('data-full');
    if (!url || turning) return;
    mark(btn);
    // data-full comes out protocol relative and currentSrc is resolved,
    // so comparing the raw strings never matches and we would re-swap
    // the picture that is already up
    var abs = function (u) { try { return new URL(u, location.href).href; } catch (e) { return u; } };
    if (abs(main.currentSrc || main.src) === abs(url)) return;
    turning = true;
    var quiet = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!quiet) main.classList.add('is-turning');
    // On a slow line the very first click can outrun the warming, and a
    // picture held at a quarter opacity for six seconds looks broken
    // rather than busy. So the fade gets a fuse: if the new one is not
    // ready quickly the old one comes back to full strength and the
    // thumbnail says it is working instead.
    var settled = false;
    var fuse = setTimeout(function () {
      if (settled) return;
      main.classList.remove('is-turning');
      btn.classList.add('is-waiting');
    }, 220);
    warm(url).then(function () {
      settled = true;
      clearTimeout(fuse);
      btn.classList.remove('is-waiting');
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = url;
      var frame = main.closest('.framed');
      if (frame) frame.classList.toggle('framed--plain', btn.getAttribute('data-kind') === 'photo');
      requestAnimationFrame(function () {
        main.classList.remove('is-turning');
        turning = false;
      });
    });
  }

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () { swap(btn); });
    // the reach is the signal: warm what they are about to ask for
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
      btn.addEventListener(ev, function () { warm(btn.getAttribute('data-full')); },
                           ev === 'touchstart' ? { passive: true } : false);
    });
  });
  mark(thumbs[0]);

  var conn = navigator.connection || {};
  var thrifty = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  if (!thrifty) {
    var soon = window.requestIdleCallback ||
      function (fn) { return setTimeout(fn, 1200); };
    soon(function () {
      thumbs.forEach(function (b) { warm(b.getAttribute('data-full')); });
    }, { timeout: 3000 });
  }
})();


/* the reading page: the ink thread fills as the reader travels the
   piece. sentences: how far into the page you are. */
(function () {
  'use strict';
  var art = document.querySelector('.article');
  if (!art) return;

  var thread = document.createElement('div');
  thread.className = 'read-thread';
  document.body.appendChild(thread);
  var ticking = false;
  function paint() {
    ticking = false;
    var r = art.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var done = Math.min(Math.max(-r.top, 0), Math.max(total, 1));
    var p = total > 0 ? done / total : 1;
    thread.style.width = (p * 100).toFixed(2) + '%';
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(paint); }
  }, { passive: true });
  paint();

})();

/* the wander door: a page at random from the shelf */
(function () {
  'use strict';
  var shelf = document.querySelector('.shelf');
  if (!shelf) return;
  function pick() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.shelf-row'));
    if (!rows.length) return;
    var url = rows[Math.floor(Math.random() * rows.length)].getAttribute('href');
    window.location.href = url;
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-wander]'), function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); pick(); });
  });
  if (/[?&]wander=1/.test(window.location.search)) pick();
})();


/* the text-size instrument: three honest sizes, remembered. the whole
   site is built in rem, so the layout scales with the reader. */
(function () {
  'use strict';
  var root = document.documentElement;
  var box = document.querySelector('[data-textsize]');
  if (!box) return;
  var KEY = 'gsuw-textsize';
  var buttons = box.querySelectorAll('[data-ts]');

  function state() {
    if (root.classList.contains('text-xl')) return 'text-xl';
    if (root.classList.contains('text-lg')) return 'text-lg';
    return '';
  }
  function paint() {
    var s = state();
    Array.prototype.forEach.call(buttons, function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ts') === s ? 'true' : 'false');
    });
  }
  Array.prototype.forEach.call(buttons, function (b) {
    b.addEventListener('click', function () {
      root.classList.remove('text-lg', 'text-xl');
      var v = b.getAttribute('data-ts');
      if (v) root.classList.add(v);
      try {
        if (v) { window.localStorage.setItem(KEY, v); }
        else { window.localStorage.removeItem(KEY); }
      } catch (e) {}
      paint();
      box.removeAttribute('open');
    });
  });
  document.addEventListener('click', function (e) {
    if (box.hasAttribute('open') && !box.contains(e.target)) box.removeAttribute('open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box.hasAttribute('open')) {
      box.removeAttribute('open');
      box.querySelector('summary').focus();
    }
  });
  paint();
})();


/* the issue on the table: issuu loads only when the cover is opened,
   and putting the book down unloads it again. sentence: you chose to
   open another publication's book; nothing followed you until then. */
(function () {
  'use strict';
  var table = document.querySelector('[data-issuu]');
  if (!table) return;
  var facade = table.querySelector('.issue-facade');
  var reader = table.querySelector('.issue-reader');
  var frame = table.querySelector('.issue-frame');
  var openBtn = table.querySelector('[data-issuu-open]');
  var closeBtn = table.querySelector('[data-issuu-close]');
  if (!facade || !reader || !frame || !openBtn || !closeBtn) return;

  openBtn.addEventListener('click', function () {
    var iframe = document.createElement('iframe');
    iframe.src = table.getAttribute('data-src');
    iframe.title = table.getAttribute('data-title') || 'Magazine reader';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');
    frame.appendChild(iframe);
    facade.hidden = true;
    reader.hidden = false;
    reader.scrollIntoView({ block: 'start' });
    closeBtn.focus({ preventScroll: true });
  });
  closeBtn.addEventListener('click', function () {
    frame.innerHTML = '';
    reader.hidden = true;
    facade.hidden = false;
    openBtn.focus({ preventScroll: true });
    table.scrollIntoView({ block: 'center' });
  });
})();


/* the larger view: opens from the hung picture or the button, fills
   about three quarters of the screen, and walks the whole set with the
   arrow keys. Zoomed in, the arrows pan instead, because that is what a
   reader reaching for them means at that moment.
   Brett asked for it 2026-09-06: clicking the picture should open it. */
(function () {
  'use strict';
  var data = document.querySelector('[data-pdp-images]');
  var btn = document.querySelector('[data-ink-close]');
  var opener = document.querySelector('[data-pdp-open]');
  if (!data && !btn) return;

  // Read fresh every time it opens. Three of the six pictures change
  // when the buyer changes the frame, so a set parsed once at load would
  // show the old frame in the larger view after a swatch click.
  function readShots() {
    var out = [];
    try { out = JSON.parse(data ? data.textContent : '[]') || []; } catch (e) { out = []; }
    if (!out.length && btn) out = [{ src: btn.getAttribute('data-src'), alt: '' }];
    return out;
  }
  var shots = readShots();
  if (!shots.length) return;

  function open(startAt, returnTo) {
    shots = readShots();
    var i = Math.max(0, Math.min(shots.length - 1, startAt || 0));
    var many = shots.length > 1;
    var wrap = document.createElement('div');
    wrap.className = 'ink-close';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'A larger view');
    wrap.innerHTML =
      // The viewing room. The panel is a photographed gallery wall, so
      // the work is seen hanging in light rather than floating in a
      // dark box, and the caption is a card on that wall the way a
      // gallery prints one. The chrome floats over the wall instead of
      // taking a row, which gives the work the whole height back.
      '<div class="ink-close-panel">' +
        '<div class="ink-close-stage"><img src="" alt="" draggable="false"></div>' +
        '<div class="ink-close-tools">' +
          (many ? '<span class="ink-close-count" data-count aria-live="polite"></span>' : '') +
          '<button type="button" class="ink-close-out" aria-label="Zoom out">&minus;</button>' +
          '<button type="button" class="ink-close-in" aria-label="Zoom in">+</button>' +
          '<button type="button" class="btn ink-close-x">Close</button>' +
        '</div>' +
        (many
          ? '<button type="button" class="ink-nav ink-nav--prev" aria-label="Previous picture">&#8249;</button>' +
            '<button type="button" class="ink-nav ink-nav--next" aria-label="Next picture">&#8250;</button>'
          : '') +
        '<figure class="ink-label">' +
          '<figcaption class="ink-label-t" data-cap></figcaption>' +
          '<p class="ink-label-hint" data-how></p>' +
        '</figure>' +
      '</div>';
    document.body.appendChild(wrap);
    document.body.style.overflow = 'hidden';

    var stage = wrap.querySelector('.ink-close-stage');
    var img = wrap.querySelector('img');
    var cap = wrap.querySelector('[data-cap]');
    var count = wrap.querySelector('[data-count]');
    var scale = 1, tx = 0, ty = 0;

    // Brett, 2026-09-06: "drag to wander does nothing". It did not. At
    // rest the whole picture is already in view, so there was nothing to
    // pan to and the clamp below pinned it at zero while the hint went
    // on promising otherwise. Two fixes: dragging at rest now walks the
    // set, with the picture following the hand a little and snapping
    // back if the pull was not enough, and the hint says whatever is
    // actually true at that moment.
    function paint() {
      if (scale === 1) {
        var give = stage.clientWidth * 0.13;
        tx = Math.max(-give, Math.min(give, tx));
        ty = 0;
      } else {
        var maxPan = 0.5 * (scale - 1);
        tx = Math.max(-maxPan * stage.clientWidth, Math.min(maxPan * stage.clientWidth, tx));
        ty = Math.max(-maxPan * stage.clientHeight, Math.min(maxPan * stage.clientHeight, ty));
      }
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function sayHow() {
      var el = wrap.querySelector('[data-how]');
      if (!el) return;
      el.textContent = scale > 1
        ? 'Drag to move around the picture. Scroll or pinch to zoom back out.'
        : (many ? 'Drag, or use the arrow keys, to move between pictures. ' : '') +
          'Scroll or pinch to zoom in.';
    }
    function zoomTo(next) {
      scale = Math.max(1, Math.min(4, next));
      if (scale === 1) { tx = 0; ty = 0; }
      paint();
      wrap.classList.toggle('is-zoomed', scale > 1);
      sayHow();
    }
    // A browser keeps painting the picture it has while the next one
    // downloads, so walking the set showed the previous work under the
    // new caption for as long as the load took. Holding the neighbours
    // ready means the swap is instant in the direction a reader is
    // already going, either way round.
    var held = {};
    function hold(n) {
      var k = (n + shots.length) % shots.length;
      if (held[k]) return;
      held[k] = new Image();
      held[k].src = shots[k].src;
    }
    function show(n) {
      i = (n + shots.length) % shots.length;
      scale = 1; tx = 0; ty = 0;
      img.src = shots[i].src;
      hold(i + 1); hold(i - 1);
      img.alt = shots[i].alt || '';
      if (cap) cap.textContent = shots[i].alt || '';
      if (count) count.textContent = (i + 1) + ' of ' + shots.length;
      paint();
      wrap.classList.remove('is-zoomed');
      sayHow();
    }
    show(i);

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomTo(scale * (e.deltaY < 0 ? 1.15 : 0.87));
    }, { passive: false });
    wrap.querySelector('.ink-close-in').addEventListener('click', function () { zoomTo(scale * 1.4); });
    wrap.querySelector('.ink-close-out').addEventListener('click', function () { zoomTo(scale / 1.4); });
    if (many) {
      wrap.querySelector('.ink-nav--prev').addEventListener('click', function () { show(i - 1); });
      wrap.querySelector('.ink-nav--next').addEventListener('click', function () { show(i + 1); });
    }

    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX - tx, y: e.clientY - ty, id: e.pointerId };
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      tx = e.clientX - drag.x; ty = e.clientY - drag.y; paint();
    });
    stage.addEventListener('pointerup', function (e) {
      // touch already has its own swipe below, and pointer events fire
      // for touch too, so a finger would otherwise count twice
      if (drag && scale === 1 && many && e.pointerType !== 'touch') {
        if (Math.abs(tx) > 55) { show(i + (tx < 0 ? 1 : -1)); drag = null; return; }
        tx = 0; paint();                      // not far enough, let it fall back
      } else if (drag && scale === 1) {
        tx = 0; paint();
      }
      drag = null;
    });
    var pinch = null;
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2) { pinch = null; return; }
      e.preventDefault();
      var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                         e.touches[0].clientY - e.touches[1].clientY);
      if (pinch) zoomTo(scale * d / pinch);
      pinch = d;
    }, { passive: false });
    stage.addEventListener('touchend', function () { pinch = null; });
    // a swipe changes the picture, but only when it is not zoomed in
    var sx = null;
    stage.addEventListener('touchstart', function (e) {
      sx = (e.touches.length === 1 && scale === 1) ? e.touches[0].clientX : null;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null || !many) return;
      var dx = (e.changedTouches[0] || {}).clientX - sx;
      if (Math.abs(dx) > 55) show(i + (dx < 0 ? 1 : -1));
      sx = null;
    });

    function close() {
      wrap.remove();
      document.body.style.overflow = '';
      if (returnTo && returnTo.focus) returnTo.focus();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === '+' || e.key === '=') { zoomTo(scale * 1.25); return; }
      if (e.key === '-') { zoomTo(scale / 1.25); return; }
      if (e.key === 'ArrowLeft')  { if (scale > 1) { tx += 60; paint(); } else if (many) show(i - 1); }
      if (e.key === 'ArrowRight') { if (scale > 1) { tx -= 60; paint(); } else if (many) show(i + 1); }
      if (e.key === 'ArrowUp')    { if (scale > 1) { ty += 60; paint(); } }
      if (e.key === 'ArrowDown')  { if (scale > 1) { ty -= 60; paint(); } }
      // keep the tab ring inside the panel
      if (e.key === 'Tab') {
        var f = wrap.querySelectorAll('button');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    }
    wrap.querySelector('.ink-close-x').addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onKey);
    wrap.querySelector('.ink-close-x').focus();
  }

  if (opener) opener.addEventListener('click', function () { open(currentIndex(), opener); });
  if (btn) btn.addEventListener('click', function () { open(currentIndex(), btn); });

  // whichever thumbnail is hung right now is where the viewer opens
  function currentIndex() {
    var main = document.getElementById('PdpImage') || document.querySelector('.pdp-wall img');
    var src = main ? (main.currentSrc || main.src || '') : '';
    var base = src.split('?')[0].split('/').pop();
    for (var k = 0; k < shots.length; k++) {
      if (shots[k].src.split('?')[0].split('/').pop() === base) return k;
    }
    return 0;
  }
})();

/* The three pictures that follow the frame.

   Brett, 2026-09-06: choosing White should turn the whole set white,
   not just the swatch. The room, the corner and the back all depend on
   the frame; the plate, the detail and the sheet of all four do not.

   The other versions are not product media. They are files, and their
   addresses come down in one metafield, so this swaps three pictures by
   address and the strip stays six long. Nothing is added or removed, so
   the count, the order and the larger view's counter are all unchanged.

   The new pictures are decoded before they go in, the same way the
   thumbnails are, so the swap is a frame rather than a stall. */
(function () {
  'use strict';
  var mapEl = document.querySelector('[data-frame-media]');
  var select = document.querySelector('[data-variant-fallback] select');
  var setEl = document.querySelector('[data-pdp-images]');
  if (!mapEl || !select || !setEl) return;
  var map = {};
  try { map = JSON.parse(mapEl.textContent) || {}; } catch (e) { return; }
  var main = document.getElementById('PdpImage') || document.querySelector('.pdp-wall img');
  var thumbs = [].slice.call(document.querySelectorAll('.pdp-thumb[data-slot]'));
  if (!thumbs.length) return;

  function frameOf() {
    var opt = select.options[select.selectedIndex];
    if (!opt) return '';
    var vals = (opt.getAttribute('data-opts') || '').split('~~');
    for (var k = 0; k < vals.length; k++) {
      if (map[vals[k]]) return vals[k];
    }
    return '';
  }

  // Shopify's CDN sizes on request, so a thumbnail asks for a thumbnail
  // rather than pulling a 1856 pixel file into a 64 pixel box.
  function sized(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var warmed = {};
  function warm(url) {
    if (!url) return Promise.resolve();
    if (warmed[url]) return warmed[url];
    var im = new Image();
    im.src = url;
    warmed[url] = im.decode ? im.decode().catch(function () {}) : Promise.resolve();
    return warmed[url];
  }

  var showing = frameOf();
  function paint(frame) {
    var set = map[frame];
    if (!set || frame === showing) return;
    var abs = function (u) { try { return new URL(u, location.href).href; } catch (e) { return u; } };
    var shots = [];
    try { shots = JSON.parse(setEl.textContent) || []; } catch (e) { shots = []; }
    var jobs = thumbs.map(function (t) {
      var slot = t.getAttribute('data-slot');
      var next = set[slot];
      if (!next) return null;
      return warm(sized(next.src, 1200)).then(function () { return { t: t, slot: slot, next: next }; });
    }).filter(Boolean);
    Promise.all(jobs).then(function (done) {
      done.forEach(function (j) {
        var cur = abs(main.currentSrc || main.src).split('?')[0];
        var wasShowing = cur === abs(j.t.getAttribute('data-full')).split('?')[0];
        j.t.setAttribute('data-full', sized(j.next.src, 1200));
        j.t.setAttribute('aria-label', j.next.alt);
        var ti = j.t.querySelector('img');
        if (ti) {
          // srcset beats src, so setting src alone changed the attribute
          // and not one pixel of what was on the screen. Found by rig on
          // 2026-09-06 after Brett saw the thumbnails stay put.
          ti.removeAttribute('srcset');
          ti.removeAttribute('sizes');
          ti.src = sized(j.next.src, 160);
          ti.alt = j.next.alt;
        }
        // the larger view walks this set, so it has to move too
        for (var n = 0; n < shots.length; n++) {
          if (shots[n].slot === j.slot) {
            shots[n].src = sized(j.next.src, 2400);
            shots[n].alt = j.next.alt;
          }
        }
        if (wasShowing && main) {
          main.removeAttribute('srcset'); main.removeAttribute('sizes');
          main.src = sized(j.next.src, 1200); main.alt = j.next.alt;
        }
      });
      setEl.textContent = JSON.stringify(shots);
      showing = frame;
    });
  }

  select.addEventListener('change', function () { paint(frameOf()); });
})();


/* the option picker: one control per product option, driving the select
   underneath. Paid for on 2026-09-06, when the Printumo catalogue
   arrived with Size and Frame and the single select became a list of
   twelve combinations nobody could read. */
(function () {
  'use strict';
  var groups = document.querySelector('[data-opt-groups]');
  var select = document.getElementById('VariantSelect');
  if (!groups || !select) return;
  var fallback = document.querySelector('[data-variant-fallback]');
  var priceOut = groups.querySelector('[data-opt-price]');
  var SEP = '~~';

  // Every option element carries its own values, so nothing is parsed
  // back out of a human-readable label.
  var variants = Array.prototype.map.call(select.options, function (o, i) {
    return { i: i, opts: (o.getAttribute('data-opts') || '').split(SEP),
             price: o.getAttribute('data-price') || '', disabled: o.disabled };
  });
  // slice, or `chosen` aliases that variant's own options array and the
  // first change corrupts the table it is looked up in. Brett caught the
  // symptom: picking Dark Oak struck Oak out as unavailable.
  var chosen = ((variants[select.selectedIndex] || variants[0] || {}).opts || []).slice();

  function rows() { return Array.prototype.slice.call(groups.querySelectorAll('.opt-group')); }

  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) { if (v.opts[j] !== vals[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function paint() {
    rows().forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-opt-index'), 10);
      var current = row.querySelector('[data-opt-current]');
      if (current) current.textContent = chosen[idx] || '';
      Array.prototype.forEach.call(row.querySelectorAll('.opt'), function (b) {
        var val = b.getAttribute('data-opt-value');
        b.setAttribute('aria-pressed', val === chosen[idx] ? 'true' : 'false');
        // grey a value that cannot be reached with the rest of the choice
        var trial = chosen.slice(); trial[idx] = val;
        var v = findVariant(trial);
        b.disabled = !v || v.disabled;
      });
    });
    var v = findVariant(chosen);
    if (v) {
      select.selectedIndex = v.i;
      if (priceOut) priceOut.textContent = v.price;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  groups.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.opt') : null;
    if (!b || b.disabled) return;
    var row = b.closest('.opt-group');
    chosen[parseInt(row.getAttribute('data-opt-index'), 10)] = b.getAttribute('data-opt-value');
    paint();
  });

  // Only now is the pretty control real, so only now is the select retired.
  groups.hidden = false;
  if (fallback) fallback.hidden = true;
  paint();
})();

/* on your wall: opened as a stage from the buy column. true scale
   over the two-metre sofa, size chips drive the real size select, and
   the page stays short. */
(function () {
  'use strict';
  var box = document.querySelector('[data-onwall]');
  if (!box) return;
  var art = box.querySelector('.onwall-art');
  var room = box.querySelector('.onwall-room');
  var select = document.getElementById('VariantSelect');
  var openBtn = document.querySelector('[data-onwall-open]');
  var closeBtn = box.querySelector('[data-onwall-close]');
  var chipsHost = box.querySelector('[data-onwall-sizes]');
  if (!art || !room || !openBtn) return;

  var ppw = parseFloat(box.getAttribute('data-ppw')) || 10;
  var wallX = parseFloat(box.getAttribute('data-wall-x')) || 50;
  var wallY = parseFloat(box.getAttribute('data-wall-y')) || 34;
  var sizes = {
    small: parseFloat(box.getAttribute('data-small')) || 12,
    medium: parseFloat(box.getAttribute('data-medium')) || 18,
    large: parseFloat(box.getAttribute('data-large')) || 24
  };
  var ratio = (parseFloat(art.getAttribute('height')) || 1) / (parseFloat(art.getAttribute('width')) || 1);

  // The label may carry both units, "20 x 25 cm / 8 x 10 in". Read the
  // inches. Reading the first pair found treated 25 cm as 25 inches and
  // hung everything two and a half times too big (2026-09-06).
  function inchesFrom(label) {
    var s = String(label || '');
    var seg = s.split('/').filter(function (part) { return /[\u2033"]|inch|\bin\b/i.test(part); })[0];
    var m = (seg || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if (m) return Math.max(parseFloat(m[1]), parseFloat(m[2]));
    var t = s.toLowerCase();
    if (t.indexOf('small') > -1) return sizes.small;
    if (t.indexOf('large') > -1) return sizes.large;
    if (t.indexOf('medium') > -1) return sizes.medium;
    var cm = s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
    if (cm) return Math.max(parseFloat(cm[1]), parseFloat(cm[2])) / 2.54;
    var any = s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if (any) return Math.max(parseFloat(any[1]), parseFloat(any[2]));
    return sizes.medium;
  }
  function currentInches() {
    var row = document.querySelector('.opt-group[data-opt-index="0"] .opt[aria-pressed="true"]');
    if (row) return inchesFrom(row.getAttribute('data-opt-value'));
    if (!select) return sizes.medium;
    return inchesFrom((select.options[select.selectedIndex] || {}).text || '');
  }
  function paint() {
    var longSide = currentInches();
    var wIn = ratio <= 1 ? longSide : longSide / ratio;
    art.style.width = (wIn * ppw / 1800) * 100 + '%';
    art.style.left = wallX + '%';
    art.style.top = wallY + '%';
    if (chipsHost) {
      var live = document.querySelector('.opt-group[data-opt-index="0"] .opt[aria-pressed="true"]');
      var liveVal = live ? live.getAttribute('data-opt-value') : null;
      Array.prototype.forEach.call(chipsHost.querySelectorAll('button'), function (c) {
        var byValue = c.getAttribute('data-opt-value');
        c.setAttribute('aria-pressed',
          byValue !== null
            ? (byValue === liveVal ? 'true' : 'false')
            : (c.getAttribute('data-i') == String(select ? select.selectedIndex : -1) ? 'true' : 'false'));
      });
    }
  }

  // One chip per SIZE, never one per variant. With two options that was
  // twelve chips of wrapped text across the bar (2026-09-06).
  var sizeRow = document.querySelector('.opt-group[data-opt-index="0"]');
  if (chipsHost && sizeRow) {
    Array.prototype.forEach.call(sizeRow.querySelectorAll('.opt'), function (src) {
      var c = document.createElement('button');
      c.type = 'button';
      c.setAttribute('data-opt-value', src.getAttribute('data-opt-value'));
      var main = src.querySelector('.opt-main');
      c.textContent = main ? main.textContent.trim() : src.textContent.trim();
      c.addEventListener('click', function () { src.click(); });
      chipsHost.appendChild(c);
    });
  } else if (chipsHost && select) {
    for (var i = 0; i < select.options.length; i++) {
      var c2 = document.createElement('button');
      c2.type = 'button';
      c2.setAttribute('data-i', i);
      c2.textContent = select.options[i].text.split('·')[0].trim();
      c2.addEventListener('click', function () {
        select.selectedIndex = parseInt(this.getAttribute('data-i'), 10);
        select.dispatchEvent(new Event('change'));
      });
      chipsHost.appendChild(c2);
    }
  }
  if (select) select.addEventListener('change', paint);

  function close() {
    box.hidden = true;
    document.body.style.overflow = '';
    openBtn.focus();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  openBtn.addEventListener('click', function () {
    // the stage belongs to the body: no ancestor can trap it
    if (box.parentNode !== document.body) document.body.appendChild(box);
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    paint();
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKey);
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  if (room.complete) { paint(); } else { room.addEventListener('load', paint); }
})();

/* the pairing: each of her sentences lights the part of his painting it
   is about. the active line is whichever sits in the middle band of the
   viewport; scrolling back up dims the later lamps again, so the picture
   follows the reader rather than running ahead. under reduced motion
   nothing runs and the css default, fully lit, is the designed still. */
(function () {
  'use strict';
  var root = document.querySelector('.pairing');
  if (!root) return;

  // the lamps are the same painting, lit through a mask. they take the
  // file the picture already chose for this screen, once it has arrived,
  // so the section costs one download and nothing before it is near
  var stage = root.querySelector('.pairing-stage');
  var art = root.querySelector('.pairing-paint');
  function lend() {
    var u = art && (art.currentSrc || art.src);
    if (stage && u) stage.style.setProperty('--paint', 'url("' + u + '")');
  }
  if (art) {
    if (art.complete && art.naturalWidth) lend();
    else art.addEventListener('load', lend, { once: true });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var total = steps.length;
  // armed as the section approaches, so the state the page loads in is
  // the lit one (Lighthouse audits that state) and the dark start still
  // meets every reader before the first line reaches the band
  var armed = false;
  var arm = function () {
    if (armed) return;
    armed = true;
    // the dark start needs the lamps: if the lazy picture has not come in
    // yet, ask for it now, and lend() hands it to the lamps when it lands
    if (art && !art.complete) art.loading = 'eager';
    root.classList.add('is-live');
  };
  if ('IntersectionObserver' in window) {
    var armer = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { arm(); armer.disconnect(); }
    }, { rootMargin: '60% 0px 60% 0px' });
    armer.observe(root);
  } else { arm(); }

  function setLit(n) {
    for (var i = 1; i <= total; i++) root.classList.toggle('lit-' + i, i <= n);
    steps.forEach(function (s) {
      var k = +s.getAttribute('data-step');
      s.classList.toggle('is-active', k === n);
      s.classList.toggle('is-past', k < n);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) setLit(+e.target.getAttribute('data-step'));
    });
  }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
  steps.forEach(function (s) { io.observe(s); });
})();


/* The hang lives in the head of theme.liquid, not here: pagereveal
   fires before a deferred script runs, so a listener registered from
   this file never sees it. Left as a signpost so nobody moves it back. */

